import React, { useEffect, useState } from "react";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import useMap from "./useMap";
import DfrMap from "./dfrMap";
import { ConvertDfrToFeatures, JumpToFeatures } from "./dfrUtil";

export default function DfrFlightMap({ dfr }) {
    const MAP_ID = `map-dfr-${dfr.flight_uuid}`;
    const map = useMap(MAP_ID);
    const [telemetry, setTelemetry] = useState([]);

    useEffect(() => {
        if (!dfr.telemetry) {
            return;
        }

        const fetchData = async () => {
            const requestOptions = {
                method: "GET",
                headers: { "Content-Type": "application/json" }
            };
            await fetch(`/api/telemetry/get/${dfr.flight_uuid}`, requestOptions)
                .then((response) => (response.ok ? response.json() : Promise.reject(response)))
                .then((data) => setTelemetry(data))
                .catch((err) => console.error("DFR Query Error", err.stack));
        };

        fetchData();
    }, []);

    useEffect(() => {
        if (!map || (dfr.telemetry && !telemetry)) {
            return;
        }

        const features = ConvertDfrToFeatures(dfr, telemetry);
        const source = new VectorSource({ features });
        map.addLayer(new VectorLayer({ source, zIndex: 1 }));
        JumpToFeatures(map, features);
    }, [map, telemetry]);

    return <DfrMap id={MAP_ID} />;
}
